import { render, staticRenderFns } from "./ClosureSignature.vue?vue&type=template&id=64c4d0dc&scoped=true"
import script from "./ClosureSignature.vue?vue&type=script&lang=js"
export * from "./ClosureSignature.vue?vue&type=script&lang=js"
import style0 from "./ClosureSignature.vue?vue&type=style&index=0&id=64c4d0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c4d0dc",
  null
  
)

export default component.exports